<form (ngSubmit)="submit()" [class.opacity-80]="isSubmitting" [class.pointer-events-none]="isSubmitting" [formGroup]="form" class="flex flex-col gap-4">
  <h3>{{ isEditMode ? 'Editar tarea' : 'Nueva tarea' }}</h3>

  <div class="form-control">
    <label class="text-neutral-900" for="task-name">Nombre de la tarea</label>
    <div class="input-icon">
      <input autocomplete="off" formControlName="name" id="task-name" placeholder="Por ejemplo: Revisar controles" type="text">
    </div>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="task-description">Descripcion</label>
    <textarea formControlName="description" id="task-description" placeholder="Detalle de la tarea" rows="3"></textarea>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="task-date">Fechas</label>
    <core-datepicker formControlName="dateRange" [compact]="true" [range]="true" placeholder="01/01/2024 - 05/12/2024"></core-datepicker>
  </div>

  <div class="flex flex-col lg:flex-row gap-2">
    <div class="form-control flex-1/2">
      <label class="text-neutral-900" for="task-status">Estado</label>
      <core-select formControlName="status" [options]="statusOptions" placeholder="Estado"></core-select>
    </div>
    <div class="form-control flex-1/2">
      <label class="text-neutral-900" for="task-priority">Prioridad</label>
      <core-select formControlName="priority" [options]="priorityOptions" placeholder="Prioridad"></core-select>
    </div>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="task-assignee">Responsable</label>
    <core-select formControlName="assigneeId" [options]="assigneeOptions" placeholder="Responsable"></core-select>
  </div>

  @if (errorMessage) {
    <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
  }

  <div class="w-full flex flex-row items-center gap-4">
    <button [disabled]="isSubmitting" class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]" type="submit"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem">
      <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/save.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">
        {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
      </span>
    </button>
  </div>
</form>
